import { Subtitle } from "@tremor/react";
export const PageSubtitle = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <Subtitle className="text-gray-700" data-sentry-element="Subtitle" data-sentry-component="PageSubtitle" data-sentry-source-file="PageSubtitle.tsx">{children}</Subtitle>;
};